import React, { PropsWithChildren } from 'react'
import { Tooltip, TooltipProps } from '@mui/material'
import styles from './tooltip.styl'
import { isEmpty, isFunction, isString } from 'lodash'
import cx from 'classnames'
import MultiLineText from '../new.line.text'
import type { PopperProps } from '@mui/material'

interface ChildrenProps {
  title?: string
}

export type Props = {
  className?: string
  popperProps?: Partial<PopperProps>
  description: React.ReactNode
  placement?: TooltipProps['placement']
  multiLine?: boolean
  children?: ((props: ChildrenProps) => React.ReactNode) | React.ReactNode
}
const zIndexPopperTooltip = 1000000

const TooltipWrapper: React.FC<Props> = React.memo(
  ({
    popperProps = {},
    children,
    className,
    placement,
    multiLine,
    description
  }: PropsWithChildren<Props>) => {
    const title =
      multiLine && isString(description) ? (
        <MultiLineText text={description} />
      ) : (
        description
      )
    if (!isEmpty(title)) {
      return (
        <Tooltip
          PopperProps={{
            ...popperProps,
            style: {
              zIndex: zIndexPopperTooltip,
              ...popperProps?.style
            }
          }}
          placement={placement}
          title={title}
        >
          {isFunction(children) ? (
            (children as (props) => React.ReactElement)({ title })
          ) : (
            <span
              data-tooltip={isString(description) ? description : null}
              className={cx(className, styles.tooltipWrapper)}
            >
              {children}
            </span>
          )}
        </Tooltip>
      )
    }

    return <>{children}</>
  }
)
TooltipWrapper.defaultProps = {
  multiLine: true
}

export default TooltipWrapper
